import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import ComplaintsFiltersDialog from "./ComplaintsFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";
import { displayMultiSelect } from "../Utility/ChipDisplay";

interface IComplaintsFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function ComplaintsFilters({ callTableViewModel, setCallTableViewModel }: IComplaintsFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                'Complaints'
            }
            {
                displayMultiSelect(callTableViewModel.filters.complaintsFilters.complaintCategory, 'Categories')
            }
            {
                displayMultiSelect(callTableViewModel.filters.complaintsFilters.complaint, '')
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <ComplaintsFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}